import ace from 'ace-builds/src-noconflict/ace';

export default async function loadAceDiff() {
  await import('ace-builds/src-noconflict/ext-diff');
  return ace.require('ace/ext/diff');
}
